import PageWrapper from '../PageWrapper';
import Alert from '.';
import Button from '../elements/Button';
import { ROUTES } from '../../routing';

const FullScreenAlert = ({
  text,
  onRetry,
  onGoHome = () => {
    window.location.href = ROUTES.HOME.getPath();
  },
  shouldShowGoHome = true,
}: {
  text: string;
  onRetry?: () => void;
  onGoHome?: () => void;
  shouldShowGoHome?: boolean;
}) => {
  return (
    <PageWrapper
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Alert type="error" text={text} />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '16px',
        }}
      >
        {typeof onRetry === 'function' && (
          <Button
            type="secondary"
            label="Try again"
            onClick={onRetry}
            faIcon={'fas fa-fw fa-sync'}
          />
        )}
        {shouldShowGoHome && (
          <Button
            label="Go Home"
            type="secondary"
            onClick={onGoHome}
            faIcon={'fas fa-fw fa-home'}
          />
        )}
      </div>
    </PageWrapper>
  );
};

export default FullScreenAlert;
